<template>
	<div class="onlineexamination">
		<img class="logoico" src="../assets/images/logo.png" />
		<back></back>
		<div class="onlineexaminationbox">
			<div class="boxtitle">
				<img src="../assets/images/tsbag2.png" />
				<p>{{paperName}}</p>
			</div>
			<div class="toptim">
				<div class="timel">
					<span>总分：{{scores}}分</span>&ensp;&ensp;
					<span v-if="paperList!=null">考试时间：{{paperList.limitedTime}}min</span>
				</div>
				<div class="timer"><span>剩余时间<i>{{paperTime}}</i></span></div>
			</div>
			<div class="textbox">
				<div class="textbox1">
					<div class="boxleft">
						<div class="txtitem">
							<div class="txtitemtitle">
								<img src="../assets/images/tt1.png" />
								<div>题号</div>
							</div>
							<div class="itembox">
								<div class="iii" v-if="paperList!=null"
									v-for="(item,index) in paperList.cmsSubjectList"><a
										@click="selectparanum(item.id,index+1)" href="javascript:void(0);"
										:class="{iiiactive:papernum == index + 1}">{{index + 1}}</a>
								</div>
							</div>
						</div>
					</div>
					<div class="boxright">
						<div class="txtitem">
							<div class="txtitemtitle2">
								<img src="../assets/images/tt2.png" />
								<div>题目</div>
								<a href="javascript:void(0);"><span @click="isshowmessage = true">
										<img src="../assets/images/jjbtn.png" />
										<p>交卷</p>
									</span></a>
							</div>
							<div class="questionsbox">
								<p class="qqtitle">
									{{this.showpaper!=null?this.showpaper.type=='0'?'单选':this.showpaper.type=='1'?'多选':this.showpaper.type=='2'?'判断':'':''}}-第{{papernum}}题
								</p>
								<p class="qqcontext">{{this.showpaper!=null?this.showpaper.name:''}}( )</p>
								<div class="qqitembox">
									<!-- 单选 -->
									<div v-if="this.showpaper!=null&&this.showpaper.cmsSubjectOption!=null&&this.showpaper.type=='0'"
										v-for="(item,index) in this.showpaper.cmsSubjectOption"><span></span><input
											class="input" type="radio" name="radio" :key="this.showpaper.id" @change="inputchange($event)"
											:data-type="this.showpaper.type" :data-id="this.showpaper.id"
											:data-keyword="item.keyword" />{{item.keyword}}.{{item.name}}
									</div>
									<!-- 多选 -->
									<div v-else-if="this.showpaper!=null&&this.showpaper.cmsSubjectOption!=null&&this.showpaper.type=='1'"
										v-for="(item,index) in this.showpaper.cmsSubjectOption"><span></span><input
											class="input" name="checkbox" type="checkbox" @change="inputchange($event)"
											:data-type="this.showpaper.type" :data-id="this.showpaper.id"
											:data-keyword="item.keyword"  :key="this.showpaper.id" />{{item.keyword}}.{{item.name}}
									</div>
									<!-- 判断 -->
									<ol v-else-if="this.showpaper!=null&&this.showpaper.type=='2'">
										<div>
											<span></span>
											<input class="input" type="radio" name="radio1"
												@change="inputchange($event)" :data-type="this.showpaper.type"
												:data-id="this.showpaper.id" value="true"  :key="this.showpaper.id" />正确
										</div>
										<div>
											<span></span>
											<input class="input" type="radio" name="radio1"
												@change="inputchange($event)" :data-type="this.showpaper.type"
												:data-id="this.showpaper.id" value="false"  :key="this.showpaper.id" />错误
										</div>
									</ol>

								</div>
							</div>
							<div class="questionsbtn" v-if="paperList!=null">
								<a href="javascript:void(0);" @click="syy">
									<div v-if="papernum>1"><span>上一题</span><img src="../assets/images/qqbtn1.png" />
									</div>
									<div v-else><span>上一题</span><img src="../assets/images/qqbtn2.png" /></div>
								</a>
								<a href="javascript:void(0);" @click="xyy">
									<div v-if="papernum===paperList.cmsSubjectList.length"><span>下一题</span><img
											src="../assets/images/qqbtn2.png" /></div>
									<div v-else><span>下一题</span><img src="../assets/images/qqbtn1.png" /></div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="popuptos" v-if="isshowmessage">
			<div class="popubox">
				<div class="poputitle">提示</div>
				<div class="poputext">
					试卷一经提交，不可更改，是否提交?
				</div>
				<div class="btna">
					<a class="fff" href="javascript:void(0);" @click="isshowmessage = false">取消</a>
					<a class="lll" href="javascript:void(0);" @click="submit">提交</a>
				</div>
			</div>
		</div>
		
		<div class="popuptos" v-if="isshowsubmit">
			<div class="popubox">
				<div class="poputitle">提示</div>
				<div class="poputext">
					{{submitmess}}
				</div>
				<div class="btna">
					<a href="javascript:void(0);" @click="isshowsubmit = false">确定</a>
				</div>
			</div>
		</div>
		
		<div class="popuptos" v-if="isshowsubmit2">
			<div class="popubox">
				<div class="poputitle">提示</div>
				<div class="poputext lefttt">
					<p>试卷：{{paperName}}</p>
					<p>时间：{{setData(timess)}}</p>
					<p>得分：<span>{{submitscore}}分</span></p>
				</div>
				<div class="btna">
					<a href="javascript:void(0);" @click="$router.push('/home')">确定</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	import axios from 'axios'
	export default {
		name: 'Onlineexamination',
		components: {
			back
		},
		data() {
			return {
				paperList: null,
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				showpaper: null,
				papernum: 1,
				submitlist: {
					"id": null, //试卷id 
					"userId": this.$store.state.userid, //答题人id
					"cmsSubjectList": [] //题目集合
				},
				paperName: null,//试卷名称
				paperTime: 0,//考试时间
				scores: 0,//总分
				isshowmessage: false,
				isshowsubmit: false,
				isshowsubmit2: false,
				timess: '',
				submitscore: 0,
				submitmess: ''
			}
		},
		created() {
			this.getpaperList()
		},
		methods: {
			getpaperList() { //获取试卷列表
				new Promise((resolve, reject) => {
					axios({
						url: this.$api.commonUrl + 'paper',
						type: 'GET',
						params: {
							status: 'open'
						},
						headers: {
							"Authorization": "Bearer " + this.token
						}
					}).then(res => {
						resolve(res)
					}).catch(err => {
						console.log("getpaperList", err)
					})
				}).then(reslist => {
					if (reslist.data.code == '200') {
						axios({
							url: this.$api.commonUrl + 'paper/' + reslist.data.data.list[0].id,
							type: 'GET',
							headers: {
								"Authorization": "Bearer " + this.token
							}
						}).then(res => {
							if (res.data.code == 200) {
								this.paperList = res.data.data
								this.showpaper = res.data.data.cmsSubjectList[0]
								this.submitlist.id = res.data.data.id
								this.paperName = res.data.data.name
								this.paperTime = res.data.data.limitedTime
								this.scores = res.data.data.score
								this.settime(this.paperTime)
							}
						}).catch(err => {
							console.log("login", err)
						})
					}
				})
			},
			settime(time){
				let times = parseInt(time)*60  //秒
				if(times>0){
					setInterval(()=>{
						times--
						if((times%60)>=10){
							if(parseInt(times/60)>=10){
								this.paperTime = parseInt(times/60)+':'+times%60
							}else{
								this.paperTime = '0'+parseInt(times/60)+':'+times%60
							}
						}else{
							if(parseInt(times/60)>=10){
								this.paperTime = parseInt(times/60)+':0'+times%60
							}else{
								this.paperTime = '0'+parseInt(times/60)+':0'+times%60
							}
						}
					},1000)
				}else{
					this.submit()
				}
			},
			selectparanum(id, num) { //选择左侧题目 id 题目id
				new Promise((resolve, reject) => {
					let newlist = this.paperList.cmsSubjectList.map((item) => {
						if (item.id == id) {
							return item
						}
					})
					this.papernum = num
					this.showpaper = newlist[num - 1]
					resolve(id)
				}).then(res => {
					this.changeselect(res)
				})
			},
			changeselect(id) {
				this.submitlist.cmsSubjectList.map((item) => {
					if (item.id == id) { //将此题的答案提取出来
						if (item.type == 0) { //单选题
							let allinput = document.getElementsByName("radio") //所有input
							for (let i = 0; i < allinput.length; i++) {
								if (allinput[i].getAttribute('data-keyword') == item.value) { //如果选中则记录答案
									allinput[i].checked = true
								}
							}
						} else if (item.type == 1) { //多选题
							let allinput = document.getElementsByName("checkbox") //所有input
							let str = item.value
							let strlist = str.slice(0, str.length - 1).split(',')
							for (let i = 0; i < allinput.length; i++) {
								for (let k = 0; k < strlist.length; k++) {
									if (allinput[i].getAttribute('data-keyword') == strlist[k]) {
										allinput[i].checked = true
									}
								}
							}
						} else { //判断题
							let allinput = document.getElementsByName("radio1") //所有input
							for (let i = 0; i < allinput.length; i++) {
								if (allinput[i].value == item.value) { //如果选中则记录答案
									allinput[i].checked = true
								}
							}
						}
					}
				})
				this.selectspan()
			},
			inputchange(input) { //选择答案
				let atype = parseInt(input.target.getAttribute('data-type')) //题目类型 0单选 1多选 2判断
				let aid = input.target.getAttribute('data-id') //题目ID
				let newlist = {
					"id": aid, //题目id
					"value": "", //答案（多选答案用逗号分隔   ）
					"type": atype //类型 0：单选 1：多选  2：判断
				}
				let cmsSubjectListNum = 0 //是否已经有此题答案
				this.submitlist.cmsSubjectList.map((item) => {
					if (item.id == aid) {
						cmsSubjectListNum += 1
					}
				})
				if (atype === 0) {
					let allinput = document.getElementsByName("radio") //所有input
					for (let i = 0; i < allinput.length; i++) {
						if (allinput[i].checked) { //如果选中则记录答案
							newlist.value = allinput[i].getAttribute('data-keyword')
						}
					}
					if (cmsSubjectListNum===0) { //如果没有此题答案则直接push
						this.submitlist.cmsSubjectList.push(newlist)
					} else { //如果有了则覆盖答案
						this.submitlist.cmsSubjectList.map((item) => {
							if (item.id === aid) {
								item.value = newlist.value
							}
						})
					}
				} else if (atype === 1) {
					let allinput = document.getElementsByName("checkbox") //所有input
					for (let i = 0; i < allinput.length; i++) {
						if (allinput[i].checked) { //如果选中则记录答案
							newlist.value = newlist.value + "" + allinput[i].getAttribute('data-keyword') + ","
						}
					}
					if (cmsSubjectListNum===0) { //如果没有此题答案则直接push
						this.submitlist.cmsSubjectList.push(newlist)
					} else { //如果有了则覆盖答案
						this.submitlist.cmsSubjectList.map((item) => {
							if (item.id === aid) {
								item.value = newlist.value
							}
						})
					}
				} else {
					let allinput = document.getElementsByName("radio1") //所有input
					for (let i = 0; i < allinput.length; i++) {
						if (allinput[i].checked) { //如果选中则记录答案
							newlist.value = allinput[i].value
						}
					}
					if (cmsSubjectListNum===0) { //如果没有此题答案则直接push
						this.submitlist.cmsSubjectList.push(newlist)
					} else { //如果有了则覆盖答案
						this.submitlist.cmsSubjectList.map((item) => {
							if (item.id === aid) {
								item.value = newlist.value
							}
						})
					}
				}
				this.selectspan()
			},
			submit() {
				this.isshowmessage = false
				if(this.submitlist.cmsSubjectList.length>0){
					axios({
						method: 'post',
						url: this.$api.commonUrl + 'paper/answer',
						data: this.submitlist,
						responseType: "json",
						headers: {
							"Authorization": "Bearer " + this.token
						}
					}).then(res => {
						console.log(res.data)
						if (res.data.code == '200') {
							this.submitscore = res.data.data
							this.timess = res.data.time
							this.isshowsubmit2 = true
						}else {
							this.submitmess = res.data.message
							this.isshowsubmit = true
						}
					}).catch(err => {
						console.log("Onlineexamination", err)
					})
				}else{
					this.submitmess = '请选择答案'
					this.isshowsubmit = true
				}
			},
			selectspan(){
				let allinput = document.getElementsByClassName("input")
				for(let i = 0; i < allinput.length; i++){
					if(allinput[i].checked){
						allinput[i].previousElementSibling.className = 'selectspan'
					}else{
						allinput[i].previousElementSibling.className = ''
					}
				}
			},
			syy() { //上一页
				//判断题目下表是否大于1 小于等于1则上一题失效
				if (this.papernum > 1) {
					new Promise((resolve, reject) => {
						this.papernum -= 1
						this.showpaper = this.paperList.cmsSubjectList[this.papernum - 1]
						resolve(this.paperList.cmsSubjectList[this.papernum - 1].id)
					}).then(res => {
						this.changeselect(res)
					})
				}
			},
			xyy() { //下一页
				//判断题目下标是否等于题目数量 如果等于则失效
				if (this.papernum < this.paperList.cmsSubjectList.length) {
					new Promise((resolve, reject) => {
						this.papernum += 1
						this.showpaper = this.paperList.cmsSubjectList[this.papernum - 1]
						resolve(this.paperList.cmsSubjectList[this.papernum - 1].id)
					}).then(res => {
						this.changeselect(res)
					})
				}
			},
			setData(value){
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return  y + '年' + MM + '月' + d + '日 ' + h + ':' + m + ':' + s
			},
		}
	}
</script>

<style>
	.onlineexamination {
		background: url(../assets/images/aminationbag.jpg) no-repeat;
		background-size: 120% auto;
		background-position: left center;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}
	.onlineexamination .lefttt{
		text-align: left;
	}
	.onlineexamination .lefttt span{
		color: #a73a29;
		font-size: 1.4rem;
		font-weight: bold;
	}
	.onlineexamination .popuptos .btna{
		text-align: center;
	}
.onlineexamination .popuptos .btna a{
	display: inline-block;
}
.onlineexamination .popuptos .btna .fff{
	margin-right: 1rem;
	background: #999999;
}
.onlineexamination .popuptos .btna .lll{
	margin-left: 1rem;
}
	.onlineexamination .onlineexaminationbox {
		position: absolute;
		z-index: 3;
		left: 1rem;
		top: 10rem;
		right: 1rem;
		bottom: 1rem;
		text-align: center;
	}

	.onlineexamination .boxtitle {
		height: 4.5rem;
		position: relative;
	}

	.onlineexamination .boxtitle img {
		display: block;
		width: 40rem;
		height: auto;
		margin: 0px auto;
	}

	.onlineexamination .boxtitle p {
		position: absolute;
		width: 40rem;
		height: 4.44444rem;
		top: 0px;
		bottom: 0px;
		left: 0px;
		right: 0px;
		margin: auto;
		line-height: 4.44444rem;
		font-family: 'STXingkai';
		font-size: 2rem;
		color: #FFFFFF;
	}

	.onlineexamination .textbox {
		width: 100rem;
		height: 50rem;
		background: linear-gradient(to bottom right, #aa7a57, #dbb48a);
		margin: 0px auto;
		position: relative;
	}

	.onlineexamination .textbox1 {
		background: #FFFFFF;
		position: absolute;
		top: 4px;
		left: 4px;
		right: 4px;
		bottom: 4px;
	}

	.onlineexamination .boxleft {
		width: calc(15rem - 8px);
		height: calc(100% - 8px);
		background: linear-gradient(to bottom right, #aa7a57, #dbb48a);
		float: left;
		margin: 4px;
	}

	.onlineexamination .boxright {
		width: calc(85em - 16px);
		height: calc(100% - 8px);
		background: linear-gradient(to bottom right, #aa7a57, #dbb48a);
		float: left;
		margin: 4px;
	}

	.onlineexamination .txtitem {
		background: #FFFFFF;
		width: calc(100% - 4px);
		height: calc(100% - 4px);
		margin: 2px;
		position: relative;
	}

	.onlineexamination .txtitemtitle,
	.txtitemtitle2 {
		width: calc(100% - 2px);
		height: calc(3rem - 2px);
		background: linear-gradient(to bottom right, #aa7a57, #dbb48a);
		display: block;
		border: 1px solid #FFFFFF;
	}

	.onlineexamination .txtitemtitle img,
	.txtitemtitle2 img {
		width: calc(1.5rem - 2px);
		height: auto;
		display: block;
		float: left;
		margin-left: 0.5rem;
		margin-top: 0.75rem;
		margin-right: 0.5rem;
	}

	.onlineexamination .txtitemtitle div {
		float: left;
		width: calc(100% - 3.5rem - 2px);
		height: calc(3rem - 2px);
		line-height: calc(3rem - 2px);
		font-size: 1.2rem;
		color: #FFFFFF;
		font-weight: bold;
		text-align: left;
	}

	.onlineexamination .itembox {
		width: 100%;
		height: auto;
		display: flex;
		flex-wrap: wrap;
	}

	.onlineexamination .itembox .iii {
		width: calc(100% / 4);
		height: auto;
		margin-top: 0.5rem;
	}

	.onlineexamination .itembox .iii a {
		width: 2rem;
		height: 2rem;
		border: 1px solid #cea57d;
		display: block;
		margin: 0px auto;
		color: #cea57d;
		text-decoration: none;
		font-size: 0.9rem;
		line-height: 2rem;
		text-align: center;
	}

	.onlineexamination .itembox .iii .iiiactive {
		color: #FFFFFF;
		background: #cea57d;
	}

	.onlineexamination .txtitemtitle2 div {
		float: left;
		width: calc(100% - 8.5rem - 2px);
		height: calc(3rem - 2px);
		line-height: calc(3rem - 2px);
		font-size: 1.2rem;
		color: #FFFFFF;
		font-weight: bold;
		text-align: left;
	}

	.onlineexamination .txtitemtitle2 span {
		width: 6rem;
		height: calc(3rem - 2px);
		display: block;
		float: left;
		position: relative;
	}

	.onlineexamination .txtitemtitle2 span img {
		width: 6rem;
		height: 2.5rem;
		display: block;
		margin: 0px;
		margin-top: 0.2rem;
	}

	.onlineexamination .txtitemtitle2 span p {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		line-height: calc(3rem - 2px);
		font-size: 1.2rem;
		color: #aa7a57;
	}

	.onlineexamination .questionsbox {
		padding: 0.5rem;
	}

	.onlineexamination .qqtitle {
		font-size: 1.4rem;
		color: #6c411b;
		text-align: left;
		height: 2rem;
		line-height: 2rem;
	}

	.onlineexamination .qqcontext {
		font-size: 1.3rem;
		color: #6c411b;
		text-align: left;
		height: 2rem;
		line-height: 2rem;
	}

	.onlineexamination .qqitembox {
		text-align: left;
		margin-top: 5rem;
	}

	.onlineexamination .qqitembox div {
		width: calc(100% - 1.5rem);
		height: 2.5rem;
		line-height: 2.5rem;
		font-size: 1.2rem;
		color: #6c411b;
		position: relative;
		margin-left: 1.5rem;
	}

	.onlineexamination .input {
		opacity: 0;
		position: absolute;
		left: 0.5rem;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 1.5rem;
		height: 1.5rem;
		z-index: 3;
	}

	.onlineexamination .qqitembox span {
		width: calc(1.5rem - 2px);
		height: calc(1.5rem - 2px);
		float: left;
		border: 1px solid #ba8455;
		margin: 0.5rem;
		position: relative;
	}
	.onlineexamination .qqitembox span::before{
		content: "";
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		width: 1rem;
		height: 1rem;
	}

	.onlineexamination .qqitembox .selectspan::before{
		background: #ba8455;
	}

	.onlineexamination .questionsbtn {
		height: 3rem;
		position: absolute;
		bottom: 3rem;
		width: 100%;
	}

	.onlineexamination .questionsbtn div {
		width: 12rem;
		height: 3rem;
		display: inline-block;
		line-height: 3rem;
		font-size: 1.2rem;
		color: #FFFFFF;
		text-align: center;
		margin-left: 5rem;
		margin-right: 5rem;
		position: relative;
	}

	.onlineexamination .questionsbtn div span {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		border: 0;
	}

	.onlineexamination .questionsbtn div img {
		width: 100%;
		height: auto;
	}

	.onlineexamination .logoico {
		position: absolute;
		top: 3rem;
		left: 3rem;
		width: 18rem;
	}

	.onlineexamination .toptim {
		display: flex;
		width: 2rem;
		width: 100rem;
		margin: 0px auto;
		line-height: 2rem;
	}

	.onlineexamination .toptim .timel,
	.onlineexamination .toptim .timer {
		flex: 1;
		color: #6c411b;
	}

	.onlineexamination .timel {
		text-align: left;
		font-size: 1rem;
	}

	.onlineexamination .timer {
		text-align: right;
		font-size: 1rem;
	}

	.onlineexamination .timer span {
		background: #a73a29;
		color: #fffef4;
		padding: 0.2rem 0.4rem 0.2rem 0.4rem;
	}

	.onlineexamination .timer span i {
		color: #FFFFFF;
		padding-left: 1rem;
		padding-right: 1rem;
	}
</style>
